import { Overlay } from '@radix-ui/react-dialog';
import React from 'react';

import { cn } from '@/services/utils';

const DialogOverlay = React.forwardRef<
    React.ElementRef<typeof Overlay>,
    React.ComponentPropsWithoutRef<typeof Overlay>
>(({ className, ...props }, ref) => (
    <Overlay
        ref={ref}
        className={cn(
            `tw-fixed
             tw-inset-0
             tw-z-[1045]
             tw-bg-black
             tw-bg-[#00000080]
             data-[state=open]:animate-in
             data-[state=closed]:animate-out
             data-[state=closed]:fade-out-0
             data-[state=open]:fade-in-0`,
            className
        )}
        {...props}
    />
));

DialogOverlay.displayName = Overlay.displayName;

export { DialogOverlay };
